import {
  LayoutDashboard,
  Activity,
  Users,
  AlertTriangle,
  Clock,
  Target,
  Tags,
  Bot,
} from "lucide-react";

export const REPORT_GROUPS = [
  { id: "activity", label: "Hoạt động" },
  { id: "performance", label: "Hiệu suất" },
  { id: "sales", label: "Bán hàng" },
];

export const REPORT_ITEMS = [
  {
    id: "overview",
    group: null,
    to: "/reports/overview",
    label: "Tổng quan",
    icon: LayoutDashboard,
    description: "Cửa ngõ báo cáo — KPI tổng hợp và thư viện báo cáo",
    status: "live",
  },
  {
    id: "activity",
    group: "activity",
    to: "/reports/activity",
    label: "Hoạt động",
    icon: Activity,
    description: "Hội thoại, tin nhắn, chatbot gửi tự động theo ngày",
    status: "live",
    iconTone: "bg-blue-50 text-blue-600",
  },
  {
    id: "staff",
    group: "performance",
    to: "/reports/staff",
    label: "Nhân viên",
    icon: Users,
    description: "Xếp hạng nhân viên, FRT, số hội thoại xử lý",
    status: "live",
    iconTone: "bg-indigo-50 text-indigo-600",
  },
  {
    id: "conversations",
    group: "performance",
    to: "/reports/conversations",
    label: "Hội thoại kẹt",
    icon: AlertTriangle,
    description: "Danh sách hội thoại khách nhắn nhưng chưa được trả lời",
    status: "live",
    iconTone: "bg-amber-50 text-amber-600",
  },
  {
    id: "heatmap",
    group: "performance",
    to: "/reports/heatmap",
    label: "Heatmap",
    icon: Clock,
    description: "Giờ khách nhắn nhiều — phân bố 7 ngày × 24 giờ",
    status: "live",
    iconTone: "bg-cyan-50 text-cyan-600",
  },
  {
    id: "pipeline",
    group: "sales",
    to: "/reports/pipeline",
    label: "Giai đoạn bán hàng",
    icon: Target,
    description: "Phễu bán hàng theo pipeline stage, so sánh kỳ trước",
    status: "live",
    iconTone: "bg-emerald-50 text-emerald-600",
  },
  {
    id: "tags",
    group: "sales",
    to: "/reports/tags",
    label: "Nhãn & Phân loại",
    icon: Tags,
    description: "Tình trạng tag hiện tại theo contact có hoạt động gần đây",
    status: "live",
    iconTone: "bg-rose-50 text-rose-600",
  },
  {
    id: "chatbot",
    group: "performance",
    to: null,
    label: "Chatbot performance",
    icon: Bot,
    description: "Tỷ lệ phản hồi tự động, độ bao phủ keyword",
    status: "soon",
    iconTone: "bg-violet-50 text-violet-600",
  },
];

export const getItemsInGroup = (groupId) =>
  REPORT_ITEMS.filter((it) => it.group === groupId);

export const getLiveItemsInGroup = (groupId) =>
  REPORT_ITEMS.filter((it) => it.group === groupId && it.status === "live");

export const TOP_LEVEL_ITEM = REPORT_ITEMS.find((it) => it.group === null);
